import isEmpty from 'lodash/isEmpty';
import { mappingLabelingFields } from 'pages/qa-spec/components/qa-packaging/utils';

import { checkHbcOtcType } from 'utils/qa-spec/checkTypeQaSpec';

export const primaryDisplayGroupName = 'Product Contains';

const IGNORED_FIELDS = [
  'consumerinstructions.consumerinstructions.consumerusageinstructions.value',
  'foodandbeveragepreparationserving.preparationserving.preparationinstructions.value',
  'qaspecification.safehandlinginstructions',
];

export const HIDE_GROUP_FIELDS = {
  Food: {
    hideGroupNames: [
      'Fresh - Deli',
      'Fresh - Meat',
      'Fresh - Produce',
      'Fresh - Seafood',
      'Components',
      'Pet Food',
      'Product Contains',
    ],
    ignoredFields: IGNORED_FIELDS,
  },
  'Fresh - Deli': {
    hideGroupNames: [
      'Fresh - Meat',
      'Fresh - Produce',
      'Fresh - Seafood',
      'Components',
      'Pet Food',
      'Product Contains',
    ],
    ignoredFields: IGNORED_FIELDS,
  },
  'Fresh - Meat': {
    hideGroupNames: [
      'Fresh - Deli',
      'Fresh - Produce',
      'Fresh - Seafood',
      'Components',
      'Pet Food',
      'Product Contains',
    ],
    ignoredFields: IGNORED_FIELDS,
  },
  'Fresh - Produce': {
    hideGroupNames: [
      'Fresh - Deli',
      'Fresh - Meat',
      'Fresh - Seafood',
      'Components',
      'Pet Food',
      'Product Contains',
    ],
    ignoredFields: IGNORED_FIELDS,
  },
  'Fresh - Seafood': {
    hideGroupNames: [
      'Fresh - Deli',
      'Fresh - Meat',
      'Fresh - Produce',
      'Components',
      'Pet Food',
      'Product Contains',
    ],
    ignoredFields: IGNORED_FIELDS,
  },
  'HBC / OTC': {
    hideGroupNames: [
      'Fresh - Deli',
      'Fresh - Meat',
      'Fresh - Produce',
      'Fresh - Seafood',
      'Ingredients',
      'Pet Food',
      'Product Contains',
    ],
    ignoredFields: IGNORED_FIELDS, // because now we're showing modules that duplicate the fields. So we need to add this to ignore list
  },
  'Non-Food': {
    hideGroupNames: [
      'Fresh - Deli',
      'Fresh - Meat',
      'Fresh - Produce',
      'Fresh - Seafood',
      'Ingredients',
      'Pet Food',
      'Product Contains',
    ],
    ignoredFields: IGNORED_FIELDS,
  },
  Pet: {
    hideGroupNames: [
      'Fresh - Deli',
      'Fresh - Meat',
      'Fresh - Produce',
      'Fresh - Seafood',
      // 'Claims',
      'Product Contains',
    ],
    ignoredFields: IGNORED_FIELDS,
  },
};

const handleTreeGetFields = (node, arrFields) => {
  if (node?.childGroups?.length) {
    node.childGroups.forEach((child) => handleTreeGetFields(child, arrFields));
  }
  if (node?.fields?.length) {
    node.fields.forEach((child) => {
      if (child?.fieldFullPath) arrFields.push(child.fieldFullPath);
    });
  }
};

export const getAllRequiredFields = (tree) => {
  let arrFields = [];
  tree.forEach((node) => handleTreeGetFields(node, arrFields));
  return arrFields;
};

export const getAllFieldsByGroupName = (fields) => {
  let result = {};

  fields.forEach((field) => {
    result = {
      ...result,
      [field.groupName]: {
        allFields: getAllRequiredFields([field]),
      },
    };
  });

  return result;
};

const getHideFields = (allFields, type, isDollarGeneral = false) => {
  const hideGroupNames = HIDE_GROUP_FIELDS[type]?.hideGroupNames;
  const ignoredFields = HIDE_GROUP_FIELDS[type]?.ignoredFields ?? [];

  const finalGroupNamesToHide = isDollarGeneral
    ? hideGroupNames.filter(
        (groupName) => groupName !== primaryDisplayGroupName,
      ) // Dollar General have Product Contains in default
    : hideGroupNames;

  let result = [];

  if (isEmpty(allFields) || isEmpty(type)) return [];

  if (Object.keys(allFields).length > 0 && type) {
    finalGroupNamesToHide.forEach((name) => {
      let fields = allFields?.[name]?.allFields ?? [];
      fields = fields.filter(
        (field) => !ignoredFields.includes(field?.toLowerCase()),
      );
      result = result.concat(fields);
    });
  }

  return result;
};

export const filterRequiredFieldsByGroupName = (
  allFields,
  selectedFields,
  type,
  isDollarGeneral = false,
) => {
  const hideFields = getHideFields(allFields, type, isDollarGeneral);

  return selectedFields.filter((field) => {
    return !hideFields.includes(field);
  });
};

const fieldMappings = {
  Usage: 'usage',
  'Cooking Instructions/ Directions': 'cookingInstructions',
  'Storage Instructions': 'storageInstructions',
};

export const mappingRequiredFieldsForHbcOtc = (productType, sectionField) => {
  const isHbcOtcType = checkHbcOtcType(productType);

  if (!sectionField || !sectionField.length) return [];

  if (!isHbcOtcType) return sectionField;

  return sectionField.map((section) => {
    if (section.groupName === 'Labeling') {
      return {
        ...section,
        fields: section.fields.map((field) => {
          return {
            ...field,
            displayName: fieldMappings[field.displayName]
              ? mappingLabelingFields[fieldMappings[field.displayName]]
                  ?.displayName
              : field.displayName,
          };
        }),
      };
    }
    return section;
  });
};
